import { map } from "lodash";
import { ValuesBar } from "./ValuesBar/ValuesBar";
import { useEffect, useState } from "react";
import './MultipleHorizontalValueBars.scss';

/**
 * barsData example:
 * [
 *     {
 *     signDocId: signDocId,
 *     signDocName: signDocName,
 *     values: ValueBarData[],
 *     }
 *
 * ]
 * */

/**
 * Component to display multiple horizontal value bars with proper scaling
 * 
 * @param {object} params - Component parameters
 * @param {Array} params.barsData - Array of bar data objects
 * @param {boolean} params.showPercent - Whether to show percentage values instead of absolute values
 * @returns {JSX.Element} Rendered component
 */
export const MultipleHorizontalValueBars = ({ barsData, showPercent }) => {
    const [barsValues, setBarsValues] = useState([]);

    useEffect(() => {
        // Process the data for each bar
        const processedBars = map(barsData, (barData) => {

            return {
                barId: barData.barId,
                barTitle: barData.barTitle,
                values: barData.values,
            };
        });

        setBarsValues(processedBars);
    }, [barsData, showPercent]);

    return <div className="MultipleHorizontalValueBars">
        {map(barsValues, (barData) => {
            return <div className="barWrapper" key={barData.barId}>
                <div className="barTitle">{barData.barTitle}</div>
                <div className="barComponent">
                    <ValuesBar
                        values={barData.values}
                        showPercent={showPercent}
                        small={barsValues.length > 4}
                    />
                </div>
            </div>;
        })}
    </div>;
};